// START GENAI@CHATGPT4
import { focusTrap } from '@utils/focus-trap';
import { Component, Prop, State, Listen, Event, EventEmitter, h } from '@stencil/core';


@Component({
  tag: 'vs-modal',
  styleUrl: 'vs-modal.css',
  shadow: false,
})
export class VsModal {
  @Prop() modalId: string;
  @Prop() cancelText: string;
  @Prop() confirmText: string;
  @Prop() modalTitle: string;
  @Prop() modalContent: string;
  @Prop() triggerRef: string;
  @Prop() secondaryRef: string;

  @State() prevModalId: string;
  @State() show: boolean;

  modalHeaderElement: HTMLElement;

  /**
   * @shortDescription Emit modal close event
   * @controlName modalCloseEvent */
  @Event({
    eventName: 'modalCloseEvent',
    composed: true,
    cancelable: true,
    bubbles: true,
  }) onModalCloseEventHandler: EventEmitter;

  /**
   * @shortDescription Emit modal confirm event
   * @controlName modalConfirmEvent */
  @Event({
    eventName: 'modalConfirmEvent',
    composed: true,
    cancelable: true,
    bubbles: true,
  }) onModalConfirmEventHandler: EventEmitter;


  @Listen('vs_modal_toggle', { target: 'document' })
  onclick_toggle(event: CustomEvent) {
    const id = event.detail.id;
    const isOpen = event.detail.open;
    setTimeout(() => {
      if (this.modalId === id && this.prevModalId !== this.modalId && isOpen) {
        this.toggle();
        this.prevModalId = this.modalId;
      } else if (!isOpen && this.modalId === id) {
        this.toggle();
      }
    });
  }

  @Listen('keydown.escape', { target: 'document' })
  onevent_toggle() {
    this.toggle();
  }

  onclick_confirm(e: Event) {
    e.preventDefault()
    this.show = !this.show;
    this.onModalConfirmEventHandler.emit(true);
  }

  onclick_close(e: Event) {
    e.preventDefault()
    this.onevent_toggle();
  }

  toggle() {
    this.show = !this.show;

    const toggleModalTimeOut =  setTimeout(() => {
      clearTimeout(toggleModalTimeOut);
      this.setFocus(this.show);
      this.handleModalCloseRefocusElement();
    }, 100);
  }

  handleModalCloseRefocusElement = () => {
    if (this.show === false) {
      this.onModalCloseEventHandler.emit(true);
      const toggleTimeOut = setTimeout(() => {
        clearTimeout(toggleTimeOut);
        if (document.getElementById(this.triggerRef)) {
          document.getElementById(this.triggerRef).focus();
        } else {
          document.getElementById(this.secondaryRef)?.focus();
        }
      }, 100);
    }
  };

  setFocus(isShow: boolean) {
    const modalFocusTimeOut = setTimeout(() => {
      clearTimeout(modalFocusTimeOut);
      if (this.modalHeaderElement) {
        this.modalHeaderElement.focus({
          preventScroll: true,
        });
      }

      focusTrap('.vs-modal-container', !isShow);
    }, 0);
  }

  disconnectedCallback() {
    document.body.classList.remove('vs-modal-body');
  }


  render() {
    return (
      this.show && (
        <div tabindex='-1' role='dialog'
             id={`mainModal${this.modalId}`}
             aria-labelledby={`title-${this.modalId}`}
             aria-describedby={this.modalId}
             aria-modal={this.show}>
          <div class='vs-modal-container' role='document'>
            <div class='vs-modal-header'>
              {this.modalTitle && (
                <h2 tabindex='-1' id={`title-${this.modalId}`}
                    ref={el => this.modalHeaderElement = el as HTMLElement}
                    class='vs-h2'>
                  {this.modalTitle}
                </h2>
              )}
            </div>
            <div class='vs-modal-content vs-text vs-d-flex vs-flex-column vs-justify-content-between'>
              <div class='vs-d-flex vs-flex-column vs-flex-grow-1'>{this.modalContent}</div>
              <div class='vs-d-flex vs-justify-content-end w-100'>
                {this.confirmText && <button class='vs-btn vs-m-auto' onClick={(evt) => this.onclick_confirm(evt)}
                                             aria-label={'close modal'}>
                  {this.confirmText || 'Ok'}
                </button>}
                <button class='vs-btn vs-m-auto' onClick={(evt) => this.onclick_close(evt)}
                        aria-label={'close modal'}>
                  {this.cancelText || 'Close'}
                </button>
              </div>
            </div>
            <button class='visa-icon visa-icon-close' onClick={(evt) => this.onclick_close(evt)} aria-label={this.cancelText}>
              <span class='vs-sr-only'>close modal</span>
            </button>
          </div>
          <div class={{'vs-modal-background': true}}></div>
        </div>
      )
    );
  }
}

// END GENAI@CHATGPT4
